import { Component, ElementRef } from '@angular/core';
import { MappingPaymentComponent } from 'app/private/paymentGateways/mapping/mapping.payment.component';
import { Translator } from 'angular-translator';
import { PaymentGatewayService } from 'app/infrastructure/services/payment.gateways.service';
import { MappingSources } from 'app/infrastructure/model/enum/mappingSources.enum';
import { BaseDesignerComponent } from '../../base/base-designer-component';
import { DesignerSelectItem } from 'app/private/sxfdesigner/types/product.type';
import { AttributeReference, AttributeChangeEventArgsType, OptionsAttribute, RuleAttribute, PageNavigationAttribute, ModalTextAttribute } from 'app/private/sxfdesigner/types/designer-attribute-type';

@Component({
    selector: 'sx-paymentgateway-designer',
    templateUrl: './paymentGatewayDesigner.component.html'
})

export class SxPaymentGatewayDesigner extends BaseDesignerComponent {

    pageList: DesignerSelectItem[] = [];
    interactionRules: DesignerSelectItem[] = [];

    constructor(container: ElementRef,
        private translator: Translator,
        private srvPayment: PaymentGatewayService) {
        super(container, 'SxPaymentGateway');
    }

    loadDefaults(): void {
        super.loadDefaults();
        this.controlContext.paymentGatewayCode = '';
        this.controlContext.selectedOptionRule = '';
        this.controlContext.actionType = 'navigation';
        this.controlContext.ruleValue = '';
        this.controlContext.onSuccess = '';
        this.controlContext.onError = '';
        this.controlContext.amount = '';
        this.controlContext.amountMapping = MappingSources.documentAttributes;
        this.controlContext.mapping = '[]';
    }

    getDesignerInfo(): any {
        const info = super.getDesignerInfo();
        info['paymentGatewayCode'] = this.controlContext.paymentGatewayCode;

        info['actionType'] = this.controlContext.actionType;
        info['ruleValue'] = this.controlContext.ruleValue;
        info['onSuccess'] = this.controlContext.onSuccess;
        info['onError'] = this.controlContext.onError;
        info['amount'] = this.controlContext.amount;
        info['amountMapping'] = this.controlContext.amountMapping;
        info['mapping'] = this.controlContext.mapping;        
        info['amountMappingTo'] = this.controlContext.amountMappingTo;        
        info['amountMappingFrom'] = this.controlContext.amountMappingFrom;        

        return info;
    }

    buildAttributes(): void {
        super.buildAttributes();

        this.pageList = this.designerContext.product.pageList;
        this.pageList.forEach(element => {
            element.description = element.id;
        })        
        
        this.interactionRules = this.designerContext.product.interactionRules;

        const paycodes = this.designerContext.product.pgCodes;
        const paymentGatewayCode = new AttributeReference(this.controlContext, paycodes, 'paymentGatewayCode', 'Payment Gateway Code');
        paymentGatewayCode.change.subscribe(v => this.onPgCodeChange(v)); 
        this.onPgCodeChange(new AttributeChangeEventArgsType (null , this.controlContext.paymentGatewayCode, null));    

        const actionTypeOptions = [
            { id: 'executeRule', name: 'ExecuteRule' },
            { id: 'navigation', name: 'Navigation' }
        ];

        const amountOptions = [
            { id: MappingSources.totalAward, description: <string>this.translator.instant('TOTAL_AWARD') },
            { id: MappingSources.firstInstallment, description: <string>this.translator.instant('FIRST_INSTALLMENT') },
            { id: MappingSources.documentAttributes, description: <string>this.translator.instant('DOCUMENT_ATTRIBUTES') },
        ];

        const actionType = new OptionsAttribute(this.controlContext, actionTypeOptions, 'actionType', 'Action Type');

        const ruleValue = new RuleAttribute(this.controlContext, this.interactionRules, 'ruleValue', 'Rule Value');
        ruleValue.hiddenConditions = [
            ['actionType', '!=', 'executeRule'],
        ];

        const onSuccess = new PageNavigationAttribute(this.controlContext, this.pageList, 'onSuccess', 'On Success');
        onSuccess.hiddenConditions = [
            ['actionType', '!=', 'navigation']
        ];

        const onError = new PageNavigationAttribute(this.controlContext, this.pageList, 'onError', 'On Error');
        onError.hiddenConditions = [
            ['actionType', '!=', 'navigation']
        ];

        const amount = new OptionsAttribute(this.controlContext, amountOptions, 'amount', 'Amount');

        const amountMappingTo = new AttributeReference(this.controlContext, [],
            'amountMappingTo', 'Payment Gateway Amount Attribute Code');
        amountMappingTo.hiddenConditions = [
            ['amount', '!=', MappingSources.documentAttributes.toString()]
        ];

        const flowattrs = this.designerContext.product.attributeCodes;
        
        const amountMappingFrom = new AttributeReference(this.controlContext, flowattrs,
            'amountMappingFrom', 'Flow Amount Attribute Code');
        amountMappingFrom.hiddenConditions = [
            ['amount', '!=', MappingSources.documentAttributes.toString()]
        ];

        const mapping = new ModalTextAttribute(this.controlContext, 'mapping', MappingPaymentComponent, 'Mapping');

        this.attributes.push(
            paymentGatewayCode,
            actionType,
            ruleValue,
            onSuccess,
            onError,
            amount,
            amountMappingTo,
            amountMappingFrom,
            mapping);
    }

    onPgCodeChange(args: AttributeChangeEventArgsType): void {
        if (args.newValue != '' && this.designerContext.selectedDesignerAtts.length != 0) {
            const modalconfig = (this.designerContext.selectedDesignerAtts.find(y => y.name === 'mapping') as ModalTextAttribute);
            const params : string[]= 
            [   
                this.designerContext.product.codSistema,
                this.designerContext.product.codNegocio,
                this.designerContext.product.codProducto,
                this.designerContext.product.documentKind,
                args.newValue
            ];
            modalconfig.setParameters(params);
            this.srvPayment.getAttributes(this.designerContext.product.codSistema, args.newValue)
                .subscribe(x => {
                    const amountMappingTo = (this.designerContext.selectedDesignerAtts.find(y => y.name === 'amountMappingTo') as AttributeReference);
                    amountMappingTo.options = x;
                    amountMappingTo.options = amountMappingTo.options.data;                                 
                })
        }
    }  
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/flow-actions/paymentGatewayDesigner.component.ts